import { TaskSummary } from "./TaskSummary";
import { TaskChat } from "./TaskChat";

interface TaskPanelProps {
  taskId: number;
  title: string;
  crontab: string | null;
}

export function TaskPanel({ taskId, title, crontab }: TaskPanelProps) {
  return (
    <div className="flex h-full min-h-0 flex-1 flex-col gap-2 lg:gap-3 overflow-hidden">
      <div className="shrink-0">
        <TaskSummary title={title} crontab={crontab} />
      </div>
      <div className="flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden">
        <TaskChat taskId={taskId} />
      </div>
    </div>
  );
}
